<script setup lang="ts">
import CustomButton from "@/components/Button/Button.vue";
import {ref} from "vue";

defineProps({
  image: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
});


</script>


<template>
  <div class="flex flex-col items-center text-center gap-4">
    <!-- Profile Image -->
    <div class="overflow-hidden rounded-full">
      <img
          :src="image"
          alt="Profile Image"
          class="min-w-44 min-h-44 rounded-full object-cover border-4 border-primary-violet duration-500 hover:scale-105"
      />
    </div>

    <div>
      <!-- Name -->
      <div class="responsive-body-large font-semibold text-primary-darkBlue">
        {{ name }}
      </div>

      <!-- Job Title -->
      <p class="text-primary-violet responsive-body-small text-nowrap">
        {{ title }}
      </p>
    </div>
    <div class="text-center">
      <CustomButton @click="$emit('view-bio')"
          type="gradient"
          :outlined="true"
          size="medium"
          :shadow="false"
          class="px-4 text-nowrap"
      >
        View Bio
      </CustomButton>
    </div>
  </div>
</template>


